import React from 'react';

import { Flex, IconError } from '@zillow/constellation';
import { StyledErrorText } from '../../StyledComponents';

const propTypes = {};
const defaultProps = {};

const PropertyLookupError = () => (
    <Flex display="flex" alignItems="center" justifyContent="center">
        <IconError fontColor="red600" size="sm" marginRight="sm" />
        <StyledErrorText
            as="div"
            fontType="bodySmall"
        >
            There was an error with lookup. Please try again.
        </StyledErrorText>
    </Flex>
);

PropertyLookupError.propTypes = propTypes;
PropertyLookupError.defaultProps = defaultProps;

export default PropertyLookupError;
